import { h, render, Component } from 'preact';
import { Route, Switch, Link } from 'react-router-dom';
import Loadable from 'react-loadable';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import coreShellConfig from 'q-core/src/shellConfig';
import { shellConfig as carsMsiteShellConfig, desktopShellConfig as carsDesktopShellConfig } from 'q-cars/src/shellConfig';
import goodsShellConfig from 'q-goods/src/shellConfig';
import monetizationShellConfig from 'q-monetization/src/shellConfig';
import jobsShellConfig from 'q-jobs/src/shellConfig';
import Shell from 'q-components/components/shell';


import styles from './index.scss';

require('preact/debug');
// import qLoader from './resources/qLoader.gif';

// render(<App />, document.getElementById('reactContainer'));

let preloadedState;
if (typeof window !== 'undefined') {
  preloadedState = window.__PRELOADED_STATE__;
}

const carsShellConfig = (preloadedState && preloadedState.isMobile) ? carsMsiteShellConfig : carsDesktopShellConfig ;

const mergedConfig = [
    ...monetizationShellConfig,
    ...carsShellConfig,
    ...goodsShellConfig,
    ...jobsShellConfig,
    ...coreShellConfig
];

const LoadableCoreApp = Loadable({
    loader: () => import('q-core/src'),
    loading: () => <div class="q-loader"></div>,
    render(loaded,props) {
        let CoreApp = loaded.default;
        return <CoreApp {...props} />;
    }
});

const LoadableCarsApp = Loadable({
    loader: () => import('q-cars/src'),
    loading: () => <div class="q-loader"></div>,
    render(loaded,props) {
        let CarsApp = loaded.default;
        return <CarsApp {...props} />;
    }
});

const LoadableGoodsApp = Loadable({
    loader: () => import('q-goods/src/index'),
    loading: () => <div class="q-loader"></div>,
    render(loaded,props) {
        let GoodsApp = loaded.default;
        return <GoodsApp {...props} />;
    }
});

const LoadableMonetizationApp = Loadable({
    loader: () => import('q-monetization/src/index'),
    loading: () => <div class="q-loader"></div>,
    render(loaded, props) {
        let MonetizationApp = loaded.default;
        return <MonetizationApp {...props} />
    }
})

const LoadableJobsApp = Loadable({
    loader: () => import('q-jobs/src/index'),
    loading: () => <div class="q-loader"></div>,
    render(loaded,props) {
        let JobsApp = loaded.default;
        return <JobsApp {...props} />;
    }
});

class QuikrApp extends Component {

    constructor(props) {
        super(props);
        this.state = {isOnline: true};
    }

    handleOnline = () => {
        this.setState({
            isOnline: true,
        });
    }

    handleOffline = () => {
        this.setState({
            isOnline: false
        });
    }

    componentDidMount() {
        this.setState({
            isOnline: navigator.onLine
        });
        window.addEventListener('offline', this.handleOffline);
        window.addEventListener('online', this.handleOnline);
    }

    componentWillUnmount() {
        window.removeEventListener('online', this.handleOnline);
        window.removeEventListener('offline', this.handleOffline);
    }

    render(props, state) {
        const url = props.url;
        const { isDesktop } = props;
        const { isOnline } = state;
        return (<div class={`app ${isOnline ? 'online' : 'offline'}`}>
            <Shell config={mergedConfig} location={url} isDesktop={isDesktop}>
                <div class="app-router">
                    <TransitionGroup>
                        <CSSTransition key={url} classNames="fade" timeout={300}>
                            <Switch>
                                <Route path="/(securepaymentpage|wallet|giftcards|giftcard/details|giftcard/categories)">
                                    <div>
                                        <LoadableMonetizationApp />
                                    </div>
                                </Route>
                                <Route path="/(cars|cars-bikes|bikes-scooters|commercial-vehicles)">
                                    <div>
                                        <LoadableCarsApp />
                                    </div>
                                </Route>
                                <Route path="/(home-lifestyle|electronics-appliances|mobiles-tablets|escrow|bazaar|quikr-assured-products.*)">
                                    <div>
                                        <LoadableGoodsApp />
                                    </div>
                                </Route>
                                <Route path="/jobs">
                                    <div>
                                        <LoadableJobsApp />
                                    </div>
                                </Route>
                                <Route path="/MyChats" >
                                    <div>
                                        <LoadableCoreApp />
                                    </div>
                                </Route>
                                <Route path="/(pets|entertainment|events|matrimonial)" >
                                    <div>
                                        <LoadableCoreApp />
                                    </div>
                                </Route>
                                <Route path="/post-classifieds-ads" >
                                    <div>
                                        <LoadableCoreApp />
                                    </div>
                                </Route>
                                <Route path="/PostAd/" >
                                    <div>
                                        <LoadableCoreApp />
                                    </div>
                                </Route>
                                <Route path="/:cityName?">
                                    <div>
                                        <LoadableCoreApp />
                                    </div>
                                </Route>
                            </Switch>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            </Shell>
        </div>);
    }
}

export default QuikrApp;



// WEBPACK FOOTER //
// ./index.js